import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-quicklinks', {
    margin: '0px',
    padding: '0px',
    display: 'block',
    listStyle: 'none',
    justifyContent: 'space-around',
    width: '100%',
});

cssRule('.tb-quicklinks-section', {
    margin: '0px 8px',
    padding: '8px 0px',
    transition: 'height 0.3s',
});

cssRule('.tb-quicklinks-section.tb-loading', {
    height: '137px',
});

cssRule('.tb-quicklinks-section.tb-empty', {
    height: 0,
    margin: 0,
    padding: 0,
    borderTop: 'none',
});

cssRule('.tb-quicklinks-section-divider', {
    borderTop: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.subtle, '#E6E6E6'),
});

cssRule('.tb-quicklinks-pending-spinner', {
    margin: '0px 8px',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
});

cssRule('.tb-quicklinks-row', {
    display: 'table',
    margin: '4px 0 0 0',
    width: '100%',
    alignItems: 'stretch',
});

cssRule('.tb-quicklinks-list', {
    alignItems: 'top',
    padding: '8px 0 8px 0',
});

cssRule('.tb-quicklinks-header', {
    font: 'BentonSans-Book-Regular',
    fontWeight: 'bold',
    fontSize: '14px',
    color: applyColor(DesignTokens.color.font.default.secondary, '#666'),
    height: '14px',
    verticalAlign: 'top',
    /* error: horizontalAlign: 'left', */
});

cssRule('.tb-quicklinks-list-item', {
    display: 'flex',
    alignItems: 'top',
});

cssRule('.tb-quicklinks-list-item-link', {
    display: 'flex',
    textAlign: 'center',
    width: '100%',
    padding: '5px 5px 5px 5px',
    flex: 29,
});

cssRule('.tb-quicklinks-list-item-link >span', {
    textAlign: 'center',
    color: applyColor(DesignTokens.color.font.default.secondary, '#666'),
});

cssRule('.tb-quicklinks-list-item-link >img', {
    height: '18px',
});

cssRule('.tb-quicklinks-list-item-link:hover, .tb-quicklinks-list-item-link:focus', {
    color: applyColor(DesignTokens.color.font.default.secondary, '#666'),
    textDecoration: 'none',
});

cssRule('.tb-quicklinks-list-item-button', {
    visibility: 'hidden',
    flex: 1,
    border: '0px',
    backgroundColor: 'transparent',
    margin: 0,
    verticalAlign: 'center',
    backgroundPosition: '8px 7px',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '14px 14px',
    backgroundImage: 'url(img/clear_14px-small.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-quicklinks-list-item-button:hover', {
    cursor: 'pointer',
    outline: 0,
    backgroundImage: 'url(img/clear_focus_14px-small.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-quicklinks-highlight', {
    textAlign: 'center',
    display: 'inline-block',
    width: '75px',
    padding: '14px 15px 10px 15px',
    margin: 0,
    color: applyColor(DesignTokens.color.font.default.secondary, '#666'),
    verticalAlign: 'top',
    height: '100%',
});

cssRule('.tb-quicklinks-highlight.activeSectionItem', {
    backgroundColor: applyColor(DesignTokens.color.component.background.toolbar.default.active, '#d4e1ed'),
});

cssRule('.tb-quicklinks-highlight >div', {
    margin: 'auto',
    height: '40px',
    width: '40px',
});

cssRule('.tb-quicklinks-highlight >div >img', {
    height: '20px',
    margin: '10px',
});

cssRule('.tb-quicklinks-highlight:hover, .tb-quicklinks-highlight:focus', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, '#F5F5F5'),
    color: applyColor(DesignTokens.color.font.default.secondary, '#666'),
    textDecoration: 'none',
});

cssRule('.tb-quicklinks-placeholder', {
    display: 'table-cell',
    width: '20%',
    padding: '14px 15px 10px 15px',
    margin: '8px 0 0 0',
});

cssRule('.tb-quicklinks-highlight-border', {
    border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.subtle, '#bfbfbf'),
    borderRadius: '50%',
});

cssRule('.tb-quicklinks-list-item-hover-focus', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, '#F5F5F5'),
});

